import { discoverBlobs } from '~/features/pin/discover';
import { copyImageDataRect } from '~/lib/utils';
import { useStore } from '~/store';
import { autoDetectGrid, uniformDividers } from './autodetect';
import { inferGridFromBlobs } from './inferFromBlobs';

const BLOB_CONFIDENCE_MIN = 0.55;

export function runAutoDetect(): void {
  const s = useStore.getState();
  // Auto-detect runs in the sprite step on the committed matte snapshot —
  // it needs alpha holes between cells, which only exist after bg removal.
  const cleaned = s.workflow.committedCleaned;
  const cropRect = s.grid.cropRect;
  if (!cleaned || !cropRect) return;
  const cropped = copyImageDataRect(cleaned, cropRect);
  const blobs = discoverBlobs(cropped, {
    alphaThreshold: s.pin.detectTolerance,
    minArea: s.pin.detectMinArea,
  });
  const inferred = inferGridFromBlobs(blobs);
  if (
    inferred &&
    inferred.confidence >= BLOB_CONFIDENCE_MIN &&
    (inferred.rows > 1 || inferred.cols > 1)
  ) {
    s.setAutoConfidence(inferred.confidence);
    s.setColDividers(inferred.colDividers.map((x) => x + cropRect.x));
    s.setRowDividers(inferred.rowDividers.map((y) => y + cropRect.y));
    return;
  }

  const fallback = autoDetectGrid(cleaned, cropRect);
  s.setAutoConfidence(fallback.confidence);
  s.setColDividers(uniformDividers(cropRect.x, cropRect.w, fallback.cols));
  s.setRowDividers(uniformDividers(cropRect.y, cropRect.h, fallback.rows));
}
